import { treeNodes, treeStrokes, treeViewBox } from "@/assets/logo/arbol";

type Props = {
  className?: string;
  /** Texto accesible. Si se omite, el logo es decorativo (aria-hidden). */
  title?: string;
};

// El árbol de circuitos vectorizado desde el logo original (scripts/vectorizar-logo.mjs).
// Va en línea para heredar currentColor y poder animar trazos y nodos con CSS.
export function LogoTree({ className, title }: Props) {
  return (
    <svg
      className={className}
      viewBox={treeViewBox}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      focusable="false"
    >
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" data-part="traces">
        {treeStrokes.map((s) => (
          <path key={s.w} d={s.d} strokeWidth={s.w} />
        ))}
      </g>
      <g fill="currentColor" data-part="nodes">
        {treeNodes.map(([cx, cy, r]) => (
          <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} />
        ))}
      </g>
    </svg>
  );
}
